import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert } from 'reactstrap';
import { GetDataRoomUploadWarning } from '../../../slices/marketplace/data-room/thunks/get-data-room-upload-warning.thunk';

export const DATA_ROOM_UPLOAD_WARNING_TEXT =
    'Anything posted here will be placed in the corresponding Data Room folder automatically.';

export interface DataRoomUploadWarningProps {
    projectId: number;
    storageFolder?: string;
    isAdminView: boolean;
    isReadonlyMode: boolean;
}

export const DataRoomUploadWarning = (props: DataRoomUploadWarningProps) => {
    const dispatch = useDispatch() as any;
    const [showWarning, setShowWarning] = useState(false);

    const isEligible =
        !!props.storageFolder && !props.isAdminView && !props.isReadonlyMode;

    useEffect(() => {
        if (!isEligible) {
            return;
        }
        dispatch(GetDataRoomUploadWarning({ projectId: props.projectId }))
            .unwrap()
            .then((result: { showWarning: boolean }) =>
                setShowWarning(!!result?.showWarning)
            )
            .catch(() => setShowWarning(false));
    }, [isEligible, props.projectId]);

    if (!isEligible || !showWarning) {
        return null;
    }

    return <Alert color="warning">{DATA_ROOM_UPLOAD_WARNING_TEXT}</Alert>;
};
